<template>
    <!-- *********************************************
    *                     Info Block                 *
    ********************************************** -->
    <divider-generic :applyBorder="false" icon="bills" :title="t('bankassurance.subscribe.auto.step5.paymentDataTitle')"/>
    <!-- Accounts Dropdown -->
    <dropdown-account
    id="originAccount"
    :params="originAccountParams"
    :options="accountsBalances"
    :selectedOption="formData.originAccount"
    @clicked="[emit('formDataChange', { field: 'originAccount', inputValue: $event }),
    emit('formDataChange', { field: 'currency', inputValue: accountsBalances.find(account => account.id === $event).currency })]"/>
    <!-- Amount -->
    <text-block-generic
    :params="{
        label: t('bankassurance.subscribe.auto.step5.amountLabel'),
        content: amountFormat(getSimulationData.quotation.premium.anualSimulatedValue, getSimulationData.quotation.premium.currency)
    }"/>
    <!-- *********************************************
    *                 Conditions Block               *
    ********************************************** -->
    <divider-generic icon="pencil-line" :title="t('bankassurance.subscribe.auto.conditionsTitle')"/>
    <!-- text-block -->
    <text-block-generic :params="{ content: t('bankassurance.subscribe.auto.conditionsWarning') }"/>
    <!-- CheckBox for terms -->
    <selector-checkbox
    canProceed="termsAndConditions"
    :label="t('bankassurance.subscribe.auto.conditions', { link: 'https://ib.bancobai.ao/FILES/COND_GERAIS_AUTO.pdf', target: '_blank'})"
    :selected="formData.canProceed"
    :errorState="showCanProceedError && !formData.canProceed"
    :errorMessage="t('mandatoryFieldError')"
    @clicked="[emit('formDataChange', { field: 'canProceed', inputValue: !formData.canProceed }), showCanProceedError = false]"/>
    <div id="canProceed"></div>
</template>

<script setup>
import DividerGeneric from '@/components/generic/dividers/Generic'
import DropdownAccount from '@/components/generic/dropdowns/accounts/Account'
import TextBlockGeneric from '@/components/generic/textBlocks/Generic'
import SelectorCheckbox from '@/components/generic/selectors/checkbox/Checkbox'

/* Vue */
import { ref, watch } from 'vue'

/* Assets */
import { amountFormat } from '@/assets/scripts/amounts'
import { getElementOffsetTopPosition } from '@/assets/scripts/htmlManipulators'

/* Store */
import { mapGetters } from '@/store/helpers/mappers'
import { moduleMapper } from '@/store/helpers/modules.map'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/* Emmitters */
const emit = defineEmits(['formDataChange', 'scrollTo'])

/* mapActions & mapGetters */
const {	getSimulationData } = mapGetters(moduleMapper.BANKASSURANCE_SUBSCRIBE)

/* props received
@accountsBalances { Array }
@formData { Object } - object with info for our current form
@mandatoryList { Array } Array of mandatory keys corresponding with our form
@showMandatoryErrors { Boolean } Prop to trigger display of mandatory errors
*/
const props = defineProps({
    accountsBalances: Array,
    formData: Object,
    mandatoryList: Array,
    showMandatoryErrors: Boolean
})

/* Data */
const originAccountParams = ref({
	labelText: t('bankassurance.subscribe.auto.step5.accountLabel'),
	mandatory: true,
	errorState: false,
    errorMessage: null
})

watch(() => props.showMandatoryErrors, newValue => {
	if (newValue) showMandatoryErrorsHandler()
    emit('resetShowMandatoryErrorsProp')
})

const showCanProceedError = ref(false)
const showMandatoryErrorsHandler = () => {
	/* Logic to scroll to first emptyField */
	if (!props.formData.canProceed) {
        showCanProceedError.value = true
        emit('scrollTo', getElementOffsetTopPosition('canProceed'))
    }
}
</script>

<style lang="scss" scoped>
</style>
